import { useSurvey } from '../SurveyContext';

export function KidsAgesStep() {
  const surveyFlow = useSurvey();
  return (
    <div className="intake-ages">
      {surveyFlow.answers.kidsAges.map((age, i) => (
        <div className="intake-age" key={i}>
          <div className="intake-agehead">
            <span className="intake-lab">Child {i + 1}</span>
            <span className="intake-ageval">
              {age} {age === 1 ? 'yr' : 'yrs'}
            </span>
          </div>
          <input
            className="intake-ageslider"
            type="range"
            min={1}
            max={4}
            step={1}
            value={age}
            onChange={(e) => surveyFlow.setAge(i, parseInt(e.target.value, 10))}
          />
        </div>
      ))}
    </div>
  );
}
